import { render, staticRenderFns } from "./shopContainer.vue?vue&type=template&id=055f12b9&scoped=true&"
import script from "./shopContainer.vue?vue&type=script&lang=js&"
export * from "./shopContainer.vue?vue&type=script&lang=js&"
import style0 from "./shopContainer.vue?vue&type=style&index=0&id=055f12b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055f12b9",
  null
  
)

export default component.exports